class ProductTabsComponent extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.selectTab(tab));
    });
  }

  selectTab(activeTab) {
    this.tabs.forEach(tab => {
      const isActive = tab === activeTab;
      tab.setAttribute('aria-selected', String(isActive));
    });
    const activeIndex = this.tabs.indexOf(activeTab);
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== activeIndex;
    });
  }
}

customElements.define('product-tabs-component', ProductTabsComponent);
